/**
 * Pixi Token State Module
 *
 * Separated from MapCanvas to avoid HMR invalidation loops.
 * This module exports a simple state flag that coordinates between
 * Pixi.js canvas clicks and React selection state.
 */

// Flag to detect if a Pixi.js token was clicked
// Used to prevent clearing selection when clicking on a token
let pixiTokenClicked = false;

export function setPixiTokenClicked(value: boolean) {
  pixiTokenClicked = value;
}

export function getPixiTokenClicked(): boolean {
  return pixiTokenClicked;
}

export function resetPixiTokenClicked(): boolean {
  const wasClicked = pixiTokenClicked;
  pixiTokenClicked = false;
  return wasClicked;
}

// Flag to detect if a Pixi.js spell effect was clicked
// Prevents MapCanvas handleClick from deselecting the effect
let pixiEffectClicked = false;

export function setPixiEffectClicked(value: boolean) {
  pixiEffectClicked = value;
}

export function resetPixiEffectClicked(): boolean {
  const wasClicked = pixiEffectClicked;
  pixiEffectClicked = false;
  return wasClicked;
}
